import { assert } from '@awayjs/graphics';
import { release } from '@awayfl/swf-loader';
var bytecodeNames = ['', 'BKPT', 'NOP', 'THROW', 'GETSUPER', 'SETSUPER', 'DXNS', 'DXNSLATE', 'KILL', 'LABEL', 'LF32X4', 'SF32X4', 'IFNLT', 'IFNLE', 'IFNGT', 'IFNGE', 'JUMP', 'IFTRUE', 'IFFALSE', 'IFEQ', 'IFNE', 'IFLT', 'IFLE', 'IFGT', 'IFGE', 'IFSTRICTEQ', 'IFSTRICTNE', 'LOOKUPSWITCH', 'PUSHWITH', 'POPSCOPE', 'NEXTNAME', 'HASNEXT', 'PUSHNULL', 'PUSHUNDEFINED', 'PUSHFLOAT', 'NEXTVALUE', 'PUSHBYTE', 'PUSHSHORT', 'PUSHTRUE', 'PUSHFALSE', 'PUSHNAN', 'POP', 'DUP', 'SWAP', 'PUSHSTRING', 'PUSHINT', 'PUSHUINT', 'PUSHDOUBLE', 'PUSHSCOPE', 'PUSHNAMESPACE', 'HASNEXT2', , , 'LI8', 'LI16', 'LI32', 'LF32', 'LF64', 'SI8', 'SI16', 'SI32', 'SF32', 'SF64', , 'NEWFUNCTION', 'CALL', 'CONSTRUCT', 'CALLMETHOD', 'CALLSTATIC', 'CALLSUPER', 'CALLPROPERTY', 'RETURNVOID', 'RETURNVALUE', 'CONSTRUCTSUPER', 'CONSTRUCTPROP', 'CALLSUPERID', 'CALLPROPLEX', 'CALLINTERFACE', 'CALLSUPERVOID', 'CALLPROPVOID', 'SXI1', 'SXI8', 'SXI16', 'APPLYTYPE', 'PUSHFLOAT4', 'NEWOBJECT', 'NEWARRAY', 'NEWACTIVATION', 'NEWCLASS', 'GETDESCENDANTS', 'NEWCATCH', , , 'FINDPROPSTRICT', 'FINDPROPERTY', 'FINDDEF', 'GETLEX', 'SETPROPERTY', 'GETLOCAL', 'SETLOCAL', 'GETGLOBALSCOPE', 'GETSCOPEOBJECT', 'GETPROPERTY', 'GETOUTERSCOPE', 'INITPROPERTY', 'UNUSED_69', 'DELETEPROPERTY', 'UNUSED_6B', 'GETSLOT', 'SETSLOT', 'GETGLOBALSLOT', 'SETGLOBALSLOT', 'CONVERT_S', 'ESC_XELEM', 'ESC_XATTR', 'CONVERT_I', 'CONVERT_U', 'CONVERT_D', 'CONVERT_B', 'CONVERT_O', 'CHECKFILTER', 'CONVERT_F', 'UNPLUS', 'CONVERT_F4', 'BC_7C', 'BC_7D', 'BC_7E', 'BC_7F', 'COERCE', 'COERCE_B', 'COERCE_A', 'COERCE_I', 'COERCE_D', 'COERCE_S', 'ASTYPE', 'ASTYPELATE', 'COERCE_U', 'COERCE_O', , , , , , , 'NEGATE', 'INCREMENT', 'INCLOCAL', 'DECREMENT', 'DECLOCAL', 'TYPEOF', 'NOT', 'BITNOT', 'UNUSED_98', 'UNUSED_99', 'UNUSED_9A', 'UNUSED_9B', 'UNUSED_9C', 'UNUSED_9D', 'UNUSED_9E', 'UNUSED_9F', 'ADD', 'SUBTRACT', 'MULTIPLY', 'DIVIDE', 'MODULO', 'LSHIFT', 'RSHIFT', 'URSHIFT', 'BITAND', 'BITOR', 'BITXOR', 'EQUALS', 'STRICTEQUALS', 'LESSTHAN', 'LESSEQUALS', 'GREATERTHAN', 'GREATEREQUALS', 'INSTANCEOF', 'ISTYPE', 'ISTYPELATE', 'IN', 'UNUSED_B5', 'UNUSED_B6', 'UNUSED_B7', 'UNUSED_B8', 'UNUSED_B9', 'UNUSED_BA', 'UNUSED_BB', 'UNUSED_BC', 'UNUSED_BD', 'UNUSED_BE', 'UNUSED_BF', 'INCREMENT_I', 'DECREMENT_I', 'INCLOCAL_I', 'DECLOCAL_I', 'NEGATE_I', 'ADD_I', 'SUBTRACT_I', 'MULTIPLY_I', 'UNUSED_C8', 'UNUSED_C9', 'UNUSED_CA', 'UNUSED_CB', 'UNUSED_CC', 'UNUSED_CD', 'UNUSED_CE', 'UNUSED_CF', 'GETLOCAL0', 'GETLOCAL1', 'GETLOCAL2', 'GETLOCAL3', 'SETLOCAL0', 'SETLOCAL1', 'SETLOCAL2', 'SETLOCAL3', 'UNUSED_D8', 'UNUSED_D9', 'UNUSED_DA', 'UNUSED_DB', 'UNUSED_DC', 'UNUSED_DD', 'UNUSED_DE', 'UNUSED_DF', 'UNUSED_E0', 'UNUSED_E1', 'UNUSED_E2', 'UNUSED_E3', 'UNUSED_E4', 'UNUSED_E5', 'UNUSED_E6', 'UNUSED_E7', 'UNUSED_E8', 'UNUSED_E9', 'UNUSED_EA', 'UNUSED_EB', 'UNUSED_EC', 'INVALID', 'UNUSED_EE', 'DEBUG', 'DEBUGLINE', 'DEBUGFILE', 'BKPTLINE', 'TIMESTAMP', 'RESTARGC', 'RESTARG', 'UNUSED_F6', 'UNUSED_F7', 'UNUSED_F8', 'UNUSED_F9', 'UNUSED_FA', 'UNUSED_FB', 'UNUSED_FC', 'UNUSED_FD', 'UNUSED_FE', 'END'];
export function getBytecodeName(bytecode) {
    return release ? 'Bytecode: ' + bytecode : bytecodeNames[bytecode];
}
/**
 * A array that maps from a bytecode value to the set of {@link OPFlags} for the corresponding instruction.
 */
export var BytecodeFlags = new Uint32Array(256);
export var BytecodeFormat = new Array(256);
function define(bytecode, format, flags) {
    if (flags === void 0) { flags = 0; }
    var instructionLength = format.length;
    BytecodeFlags[bytecode] = flags;
    BytecodeFormat[bytecode] = format;
    // release || assert (!isConditionalBranch(opcode) || isBranch(opcode), "a conditional branch must also be a branch");
}
/**
 * Only call this before the compiler is used.
 */
export function defineBytecodes() {
    define(1 /* BKPT */, '');
    define(2 /* NOP */, '');
    define(3 /* THROW */, '');
    define(4 /* GETSUPER */, 'e');
    define(5 /* SETSUPER */, 'e');
    define(6 /* DXNS */, 'e');
    define(7 /* DXNSLATE */, '');
    define(8 /* KILL */, 'e');
    define(9 /* LABEL */, '');
    define(10 /* LF32X4 */, '');
    define(11 /* SF32X4 */, '');
    define(12 /* IFNLT */, 'd');
    define(13 /* IFNLE */, 'd');
    define(14 /* IFNGT */, 'd');
    define(15 /* IFNGE */, 'd');
    define(16 /* JUMP */, 'd');
    define(17 /* IFTRUE */, 'd');
    define(18 /* IFFALSE */, 'd');
    define(19 /* IFEQ */, 'd');
    define(20 /* IFNE */, 'd');
    define(21 /* IFLT */, 'd');
    define(22 /* IFLE */, 'd');
    define(23 /* IFGT */, 'd');
    define(24 /* IFGE */, 'd');
    define(25 /* IFSTRICTEQ */, 'd');
    define(26 /* IFSTRICTNE */, 'd');
    define(27 /* LOOKUPSWITCH */, '');
    define(28 /* PUSHWITH */, '');
    define(29 /* POPSCOPE */, '');
    define(30 /* NEXTNAME */, '');
    define(31 /* HASNEXT */, '');
    define(32 /* PUSHNULL */, '');
    define(33 /* PUSHUNDEFINED */, '');
    define(35 /* NEXTVALUE */, '');
    define(36 /* PUSHBYTE */, 'b');
    define(37 /* PUSHSHORT */, 'c');
    define(38 /* PUSHTRUE */, '');
    define(39 /* PUSHFALSE */, '');
    define(40 /* PUSHNAN */, '');
    define(41 /* POP */, '');
    define(42 /* DUP */, '');
    define(43 /* SWAP */, '');
    define(44 /* PUSHSTRING */, 'e');
    define(45 /* PUSHINT */, 'e');
    define(46 /* PUSHUINT */, 'e');
    define(47 /* PUSHDOUBLE */, 'e');
    define(48 /* PUSHSCOPE */, '');
    define(49 /* PUSHNAMESPACE */, 'e');
    define(50 /* HASNEXT2 */, 'ee');
    // define(Bytecode.UNDEFINED, "");
    // define(Bytecode.UNDEFINED, "");
    define(53 /* LI8 */, '');
    define(54 /* LI16 */, '');
    define(55 /* LI32 */, '');
    define(56 /* LF32 */, '');
    define(57 /* LF64 */, '');
    define(58 /* SI8 */, '');
    define(59 /* SI16 */, '');
    define(60 /* SI32 */, '');
    define(61 /* SF32 */, '');
    define(62 /* SF64 */, '');
    define(64 /* NEWFUNCTION */, 'e');
    define(65 /* CALL */, 'e');
    define(66 /* CONSTRUCT */, 'e');
    define(67 /* CALLMETHOD */, 'ee');
    define(68 /* CALLSTATIC */, 'ee');
    define(69 /* CALLSUPER */, 'ee');
    define(70 /* CALLPROPERTY */, 'ee');
    define(71 /* RETURNVOID */, '');
    define(72 /* RETURNVALUE */, '');
    define(73 /* CONSTRUCTSUPER */, 'e');
    define(74 /* CONSTRUCTPROP */, 'ee');
    define(75 /* CALLSUPERID */, '');
    define(76 /* CALLPROPLEX */, 'ee');
    define(77 /* CALLINTERFACE */, '');
    define(78 /* CALLSUPERVOID */, 'ee');
    define(79 /* CALLPROPVOID */, 'ee');
    define(80 /* SXI1 */, '');
    define(81 /* SXI8 */, '');
    define(82 /* SXI16 */, '');
    define(83 /* APPLYTYPE */, 'e');
    define(84 /* PUSHFLOAT4 */, '');
    define(85 /* NEWOBJECT */, 'e');
    define(86 /* NEWARRAY */, 'e');
    define(87 /* NEWACTIVATION */, '');
    define(88 /* NEWCLASS */, 'e');
    define(89 /* GETDESCENDANTS */, 'e');
    define(90 /* NEWCATCH */, 'e');
    // define(Bytecode.UNDEFINED, "");
    // define(Bytecode.UNDEFINED, "");
    define(93 /* FINDPROPSTRICT */, 'e');
    define(94 /* FINDPROPERTY */, 'e');
    define(95 /* FINDDEF */, '');
    define(96 /* GETLEX */, 'e');
    define(97 /* SETPROPERTY */, 'e');
    define(98 /* GETLOCAL */, 'e');
    define(99 /* SETLOCAL */, 'e');
    define(100 /* GETGLOBALSCOPE */, '');
    define(101 /* GETSCOPEOBJECT */, 'e');
    define(102 /* GETPROPERTY */, 'e');
    define(103 /* GETOUTERSCOPE */, '');
    define(104 /* INITPROPERTY */, 'e');
    define(106 /* DELETEPROPERTY */, 'e');
    define(108 /* GETSLOT */, 'e');
    define(109 /* SETSLOT */, 'e');
    define(110 /* GETGLOBALSLOT */, 'e');
    define(111 /* SETGLOBALSLOT */, 'e');
    define(112 /* CONVERT_S */, '');
    define(113 /* ESC_XELEM */, '');
    define(114 /* ESC_XATTR */, '');
    define(115 /* CONVERT_I */, '');
    define(116 /* CONVERT_U */, '');
    define(117 /* CONVERT_D */, '');
    define(118 /* CONVERT_B */, '');
    define(119 /* CONVERT_O */, '');
    define(120 /* CHECKFILTER */, '');
    define(121 /* CONVERT_F */, '');
    define(122 /* UNPLUS */, '');
    define(123 /* CONVERT_F4 */, '');
    define(128 /* COERCE */, 'e');
    define(129 /* COERCE_B */, '');
    define(130 /* COERCE_A */, '');
    define(131 /* COERCE_I */, '');
    define(132 /* COERCE_D */, '');
    define(133 /* COERCE_S */, '');
    define(134 /* ASTYPE */, 'e');
    define(135 /* ASTYPELATE */, '');
    define(136 /* COERCE_U */, '');
    define(137 /* COERCE_O */, '');
    define(144 /* NEGATE */, '');
    define(145 /* INCREMENT */, '');
    define(146 /* INCLOCAL */, 'e');
    define(147 /* DECREMENT */, '');
    define(148 /* DECLOCAL */, 'e');
    define(149 /* TYPEOF */, '');
    define(150 /* NOT */, '');
    define(151 /* BITNOT */, '');
    define(160 /* ADD */, '');
    define(161 /* SUBTRACT */, '');
    define(162 /* MULTIPLY */, '');
    define(163 /* DIVIDE */, '');
    define(164 /* MODULO */, '');
    define(165 /* LSHIFT */, '');
    define(166 /* RSHIFT */, '');
    define(167 /* URSHIFT */, '');
    define(168 /* BITAND */, '');
    define(169 /* BITOR */, '');
    define(170 /* BITXOR */, '');
    define(171 /* EQUALS */, '');
    define(172 /* STRICTEQUALS */, '');
    define(173 /* LESSTHAN */, '');
    define(174 /* LESSEQUALS */, '');
    define(175 /* GREATERTHAN */, '');
    define(176 /* GREATEREQUALS */, '');
    define(177 /* INSTANCEOF */, '');
    define(178 /* ISTYPE */, 'e');
    define(179 /* ISTYPELATE */, '');
    define(180 /* IN */, '');
    define(192 /* INCREMENT_I */, '');
    define(193 /* DECREMENT_I */, '');
    define(194 /* INCLOCAL_I */, 'e');
    define(195 /* DECLOCAL_I */, 'e');
    define(196 /* NEGATE_I */, '');
    define(197 /* ADD_I */, '');
    define(198 /* SUBTRACT_I */, '');
    define(199 /* MULTIPLY_I */, '');
    define(208 /* GETLOCAL0 */, '');
    define(209 /* GETLOCAL1 */, '');
    define(210 /* GETLOCAL2 */, '');
    define(211 /* GETLOCAL3 */, '');
    define(212 /* SETLOCAL0 */, '');
    define(213 /* SETLOCAL1 */, '');
    define(214 /* SETLOCAL2 */, '');
    define(215 /* SETLOCAL3 */, '');
    define(237 /* INVALID */, '');
    define(239 /* DEBUG */, 'aeae');
    define(240 /* DEBUGLINE */, 'e');
    define(241 /* DEBUGFILE */, 'e');
    define(242 /* BKPTLINE */, 'e');
    define(243 /* TIMESTAMP */, '');
    // define(Bytecode.UNUSED_6B, "", Flags.NONE);
    // define(Bytecode.UNUSED_DE, "", Flags.NONE);
    // define(Bytecode.UNUSED_BB, "", Flags.NONE);
}
defineBytecodes();
var Bytes = /** @class */ (function () {
    function Bytes() {
    }
    Bytes.u8 = function (code, i) {
        return code[i];
    };
    Bytes.s32 = function (code, i) {
        var result = code[i];
        if (result & 0x80) {
            result = result & 0x7f | code[i + 1] << 7;
            if (result & 0x4000) {
                result = result & 0x3fff | code[i + 2] << 14;
                if (result & 0x200000) {
                    result = result & 0x1fffff | code[i + 3] << 21;
                    if (result & 0x10000000) {
                        result = result & 0x0fffffff | code[i + 4] << 28;
                        result = result & 0xffffffff;
                    }
                }
            }
        }
        return result;
    };
    Bytes.u32 = function (code, i) {
        return Bytes.s32(code, i) >>> 0;
    };
    Bytes.u30 = function (code, i) {
        return Bytes.u32(code, i);
    };
    Bytes.s32Length = function (code, i) {
        var result = code[i];
        if (result & 0x80) {
            result = result & 0x7f | code[i + 1] << 7;
            if (result & 0x4000) {
                result = result & 0x3fff | code[i + 2] << 14;
                if (result & 0x200000) {
                    result = result & 0x1fffff | code[i + 3] << 21;
                    if (result & 0x10000000) {
                        return 5;
                    }
                    return 4;
                }
                return 3;
            }
            return 2;
        }
        return 1;
    };
    return Bytes;
}());
export { Bytes };
function lengthAt(code, i) {
    var l = 1;
    var bytecode = code[i];
    if (bytecode === 27 /* LOOKUPSWITCH */) {
        l += 3; // Default offset.
        var n = Bytes.u30(code, i + l) + 1; // Offsets
        l += Bytes.s32Length(code, i + l);
        l += n * 3;
        return l;
    }
    var format = BytecodeFormat[bytecode];
    if (format === '') {
        return l;
    }
    assert(format, 'OP: ' + getBytecodeName(bytecode));
    for (var j = 0; j < format.length; j++) {
        var f = format[j].charCodeAt(0) - 97;
        switch (f) {
            case 0 /* u08 */:
            case 1 /* s08 */:
                l += 1;
                continue;
            case 3 /* s24 */:
                l += 3;
                continue;
            case 2 /* s16 */:
            case 4 /* u30 */:
            case 5 /* u32 */:
                l += Bytes.s32Length(code, i + l);
                continue;
        }
    }
    return l;
}
var BytecodeStream = /** @class */ (function () {
    function BytecodeStream(code) {
        this._code = code;
        this.setBCI(0);
    }
    BytecodeStream.prototype.next = function () {
        this.setBCI(this._nextBCI);
    };
    BytecodeStream.prototype.endBCI = function () {
        return this._code.length;
    };
    Object.defineProperty(BytecodeStream.prototype, "nextBCI", {
        get: function () {
            return this._nextBCI;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BytecodeStream.prototype, "currentBCI", {
        get: function () {
            return this._currentBCI;
        },
        enumerable: true,
        configurable: true
    });
    BytecodeStream.prototype.currentBytecode = function () {
        return this._bytecode;
    };
    BytecodeStream.prototype.nextBC = function () {
        return Bytes.u8(this._code, this._nextBCI);
    };
    BytecodeStream.prototype.setBCI = function (bci) {
        this._currentBCI = bci;
        if (this._currentBCI < this._code.length) {
            this._bytecode = Bytes.u8(this._code, bci);
            var l = lengthAt(this._code, bci);
            this._nextBCI = bci + l;
        }
        else {
            this._bytecode = 255 /* END */;
            this._nextBCI = this._currentBCI;
        }
    };
    return BytecodeStream;
}());
export { BytecodeStream };
